export default class Sandbox {
    constructor(adapter) {
        this.client = adapter.getSandboxClient()
    }

    async spark(name, data) {
        let res = await this.client.post(`/spark/exec/${name}`, data)

        return res.data
    }
}